/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import QS from 'qs'
import router from '../router/index'

// 环境的切换
if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = '/api/'
} else if (process.env.NODE_ENV == 'debug') {
  axios.defaults.baseURL = '/'
} else if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = '/'
}

// 请求超时时间
axios.defaults.timeout = 10000
axios.defaults.withCredentials = true

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    config.headers.common['Authorization'] = 'Bearer '+localStorage.getItem('token') || '';
    // config.headers.common['Authorization'] = '00fb4b6b53936361ed6a54bdbb12af71';
    //config.headers.common['Authorization'] = 'OWQ0OGZhNjlhNDA3OGIyYjMxNzlkYWQzZDI0ZDVlZDI=';
    return config
  },
  error => {
    return Promise.error(error)
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      switch (response.data.code) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 400302:
          setTimeout(()=>{
          }, 200)
          break
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 401:
          // 登录过期,清除token
          localStorage.removeItem('token')
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: '/login',
              query: {
                  redirect: router.currentRoute.fullPath
              }
            });
          }, 200)
          break
        // 404请求不存在
        case 404:
          break
        case 405:
          setTimeout(()=>{
            window.location.href = response.data.data.url
          }, 200)
          break
        // 其他错误，直接抛出错误提示
        default:
          // Toast({
          //     message: error.response.data.message,
          //     duration: 1500,
          //     forbidClick: trues
          // });
          return Promise.resolve(response)
      }
      if(response.data.status == 200){
        return Promise.resolve(response)
      }
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况  
  error => {
    return Promise.reject(error.response)
  }
);

export default {
  /**
   * get方法，对应get请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  get(url, params){
    return new Promise((resolve, reject) =>{
      const urlB = '/' + url
      axios.get(urlB, {
        params: params
      })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err.data)
        })
    })
  },

  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  post(url, params) {
    return new Promise((resolve, reject) => {
      const urlB = '/' + url
      axios.post(urlB, QS.stringify(params))
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err.data)
        })
    })
  },

  /**
   * post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  getUpload(url,params,config) {
    return new Promise((resolve, reject) => {
      const urlB = '/' + url
      axios.post(urlB,params,config)
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err.data)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/request.js